"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _session = require("@mulesoft/exchange-ui-portals-store/lib/domains/session");
var _Table = _interopRequireDefault(require("@mulesoft/exchange-ui-components/lib/components/Table"));
var _AssetType = _interopRequireDefault(require("@mulesoft/exchange-ui-components/lib/components/AssetType"));
var _AssetNameLink = _interopRequireDefault(require("@mulesoft/exchange-ui-components/lib/components/AssetNameLink"));
var _LifecycleStatePill = _interopRequireDefault(require("../LifecycleState/LifecycleStatePill"));
var getHeaders = function getHeaders(addStatus) {
  var headers = [{
    key: 'name',
    label: 'Name'
  }, {
    key: 'version',
    label: 'Version'
  }, {
    key: 'type',
    label: 'Type'
  }];
  if (addStatus) {
    headers.push({
      key: 'status',
      label: 'Lifecycle state'
    });
  }
  return headers;
};
var isAssetDisabled = function isAssetDisabled(asset) {
  if (!asset.permissions) {
    return false;
  }
  return !asset.permissions.length;
};
var AssetsTable = function AssetsTable(_ref) {
  var _ref$assets = _ref.assets,
    assets = _ref$assets === void 0 ? [] : _ref$assets,
    title = _ref.title,
    caption = _ref.caption,
    testId = _ref.testId,
    onAssetClick = _ref.onAssetClick;
  var isPortalReArchitectureEnabled = (0, _reactRedux.useSelector)(_session.selectors.isPIRAEnabled);
  if (!assets.length) {
    return null;
  }
  var headers = getHeaders(isPortalReArchitectureEnabled);
  var mapAssets = function mapAssets() {
    return assets.sort(function (asset) {
      return isAssetDisabled(asset) ? 1 : -1;
    }).map(function (asset) {
      return {
        name: /*#__PURE__*/_react.default.createElement(_AssetNameLink.default, {
          onClick: onAssetClick,
          asset: asset,
          isDisabled: isAssetDisabled(asset)
        }),
        version: asset.version,
        type: /*#__PURE__*/_react.default.createElement(_AssetType.default, {
          type: asset.type
        }),
        status: isPortalReArchitectureEnabled ? /*#__PURE__*/_react.default.createElement(_LifecycleStatePill.default, {
          status: asset.status,
          lightTheme: true
        }) : null,
        isDisabled: isAssetDisabled(asset)
      };
    });
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h3", null, title), /*#__PURE__*/_react.default.createElement(_Table.default, {
    headers: headers,
    caption: caption,
    rows: mapAssets(),
    testId: testId,
    isRowDisabled: function isRowDisabled(row) {
      return row.isDisabled;
    }
  }));
};
var _default = exports.default = AssetsTable;
//# sourceMappingURL=AssetsTable.js.map